document.addEventListener("DOMContentLoaded", () => {
  console.log("Welcome to Our Wedding Site!");
  import('./rsvp.ts');
});
